import React from "react";
import { openDialog } from './Application';

// Changed to default export to match how it's used in Index.js
const Subscription = () => {
    const levels = [
        { name: "Fundamental", description: "Revoluciona tu trabajo", icon:"icon-speedometer-linear" },
        { name: "Superior", description: "Eleva tus conocimientos ", icon: "icon-linegraph-linear" }
    ];

    return (
        <div className="grid" style={{ columns: 2}} >
                {levels.map((level, index) => (
                    <div key={index} className="translucid medium">
                        <h2>{level.name}</h2>
                        <br />
                        <i className={`${level.icon} icon-3x brand`}></i><span>&nbsp;</span>
                        <br /> <br />
                        <a href="#"
                            className="subscribe button"
                            onClick={(e) => {
                                e.preventDefault();
                                openDialog("email", { level: level.name }, "Nivel " + level.name);
                            }}
                        >
                            <i className="icon-world-nav"></i>Suscríbete
                        </a>
                        <br />
                        <h3>{level.description}</h3>
                    </div>
                ))}
            </div>
    );
};

export default Subscription;